"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var HttpRequestType;
(function (HttpRequestType) {
    HttpRequestType["GET"] = "get";
    HttpRequestType["POST"] = "post";
    HttpRequestType["PUT"] = "put";
    HttpRequestType["DELETE"] = "delete";
})(HttpRequestType || (HttpRequestType = {}));
exports.default = HttpRequestType;
//# sourceMappingURL=HttpRequestType.js.map